_led.addFeature('includeDocumentValidator', function (monaco, editorInstance, data) { //No I18n
  const validators = this._validators;
  if (Object.keys(validators).length > 0) {
    const doValidation = function () {
      const model = editorInstance.getModel();
      // const value = model.getValue();
      const modelLanguage = model.getLanguageId();
      const validator = validators[modelLanguage];
      if (validator) {
        const markers = validator.doValidate.call(_led, model);
        if (_led.checkType.array(markers)) {
          monaco.editor.setModelMarkers(model, validator.validatorId, []);
          let langMarkers = [];
          markers.forEach(function (marker) {
            if (_led.checkType.object(marker)) {
              const getSeverity = function (type) {
                let fallbackValue = monaco.MarkerSeverity.Error;
                if (_led.checkType.string(type)) {
                  type = type ? type.toLowerCase() : '';
                  type = type.slice(0, 1).toUpperCase() + type.slice(1);
                  return monaco.MarkerSeverity[type] || fallbackValue;
                }
                return fallbackValue;
              }
              if (marker && marker.lineNumber !== null) {
                langMarkers.push({
                  startLineNumber: marker.startLineNumber || marker.lineNumber,
                  startColumn: marker.startColumn ||  model.getLineFirstNonWhitespaceColumn(marker.lineNumber),
                  endColumn: marker.endColumn ||  model.getLineLength(marker.lineNumber),
                  endLineNumber: marker.endLineNumber ||  marker.lineNumber,
                  message: marker.message || 'Unknown Error',//No I18n
                  severity: getSeverity(marker.type)
                })
              }
            } else {
              _led.throw.warning(_led.error.EXPECTED, 'object', marker);//No I18n
            }
          });
          monaco.editor.setModelMarkers(model, validator.validatorId, langMarkers);
        } else {
          _led.throw.warning(_led.error.EXPECTED, 'array', markers);//No I18n
        }
      }
    }
    // ? Did this for validating the first time
    doValidation();
    editorInstance.onDidChangeModelContent(doValidation)
  }
});